<template>
  <VerifyLetters />
</template>

<script>
import VerifyLetters from '@/components/VerifyLetters.vue'

export default {
  name: 'HomeView',
  components: {
    VerifyLetters
  }
}
</script>
